function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import ServiceFactory from "../../service";
import { Link } from "react-router-dom";
import { PageHeader, Card, Segmented, Filters, Empty, Pending } from "../../components/analytics-kit";
import publishSearch from "../../functions/publish-search";
import publishEvent from "../../functions/publish-event";
import { InboxRow } from "../../components/notification-panel";
import { listInbox, markRead, markAllRead, openItem, getPreferences, savePreferences, SOURCE_LABEL, onUnread } from "../../functions/inbox";

/*
 * Notifications (PlunkDocs specs/CONTENT_HUB_REVIEW_DESK_2026-10-21.md, mockups H and J). The signed-in person's inbox:
 * everything the bell shows, filterable, with paging; /Notifications/settings chooses which kinds reach the bell.
 * Replaces the old "Your inbox is currently empty" placeholder.
 */
const FILTERS = [["all", "All"], ["unread", "Unread"], ["action", "Needs you"]];
const APPS = [["commerce", "Commerce"], ["", "Commerce and Studio"]];
class NotificationsView extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      items: null,
      filter: "all",
      app: "commerce",
      more: false,
      busy: false,
      error: false,
      unread: 0,
      prefs: null,
      catalog: [],
      saving: false,
      saved: false
    });
    _defineProperty(this, "load", async (patch, append) => {
      const st = {
        ...this.state,
        ...(patch || {})
      };
      this.setState({
        ...(patch || {}),
        busy: true,
        error: false,
        ...(append ? {} : {
          items: null
        })
      });
      try {
        const before = append && this.state.items && this.state.items.length ? this.state.items[this.state.items.length - 1].sentAt : null;
        const r = await listInbox({
          filter: st.filter,
          app: st.app || null,
          before,
          limit: 30
        });
        if (!this._alive) return;
        this.setState({
          items: append ? (this.state.items || []).concat(r.items) : r.items,
          more: r.items.length === 30,
          busy: false
        });
      } catch (e) {
        if (this._alive) this.setState({
          items: append ? this.state.items : [],
          busy: false,
          error: true
        });
      }
    });
    _defineProperty(this, "open", async item => {
      if (!item.read) {
        try {
          await markRead(item.id);
        } catch (e) {/* still open it */}
      }
      if (item.deeplinkUrl) openItem(item, this.props.history);else this.setState({
        items: (this.state.items || []).map(i => i.id === item.id ? {
          ...i,
          read: true
        } : i)
      });
    });
    _defineProperty(this, "readAll", async () => {
      try {
        await markAllRead();
        this.load();
      } catch (e) {/* keep */}
    });
    _defineProperty(this, "loadPrefs", async () => {
      this.setState({
        prefs: null,
        error: false
      });
      try {
        const r = await getPreferences();
        if (this._alive) this.setState({
          prefs: r && r.preferences || {},
          catalog: r && r.catalog || []
        });
      } catch (e) {
        if (this._alive) this.setState({
          prefs: {},
          error: true
        });
      }
    });
    _defineProperty(this, "digestTest", async () => {
      try {
        const S = ServiceFactory.getType("/content/digest/test", "product");
        await new S().postAsync({});
        this.setState({
          testSent: true
        });
      } catch (e) {/* keep */}
    });
    _defineProperty(this, "toggle", type => {
      const prefs = {
        ...(this.state.prefs || {})
      };
      const events = {
        ...(prefs.events || {})
      };
      events[type] = {
        ...(events[type] || {}),
        inbox: !this.inboxOn(type)
      };
      this.setState({
        prefs: {
          ...prefs,
          events
        },
        saved: false
      });
    });
    _defineProperty(this, "save", async () => {
      this.setState({
        saving: true,
        saved: false,
        error: false
      });
      try {
        await savePreferences(this.state.prefs || {});
        if (this._alive) this.setState({
          saving: false,
          saved: true
        });
      } catch (e) {
        if (this._alive) this.setState({
          saving: false,
          error: true
        });
      }
    });
  }
  settings() {
    return /\/settings$/i.test(this.props.location && this.props.location.pathname || "");
  }
  componentDidMount() {
    this._alive = true;
    publishSearch("Notifications");
    publishEvent("reset-search", {});
    this._off = onUnread(n => this._alive && this.setState({
      unread: n
    }));
    if (this.settings()) this.loadPrefs();else this.load();
  }
  componentDidUpdate(prev) {
    const was = /\/settings$/i.test(prev.location && prev.location.pathname || "");
    if (was !== this.settings()) {
      if (this.settings()) this.loadPrefs();else this.load();
    }
  }
  componentWillUnmount() {
    this._alive = false;
    if (this._off) this._off();
  }
  inboxOn(type) {
    const e = ((this.state.prefs || {}).events || {})[type];
    return !e || e.inbox !== false;
  }
  renderSettings() {
    const {
      prefs,
      catalog,
      error
    } = this.state;
    if (!prefs) return /*#__PURE__*/React.createElement(Card, {
      title: "What reaches your bell"
    }, /*#__PURE__*/React.createElement(Pending, null));
    const groups = [];
    catalog.forEach(c => {
      const g = groups.find(x => x.name === c.group);
      if (g) g.items.push(c);else groups.push({
        name: c.group,
        items: [c]
      });
    });
    const digest = !!(prefs.digest && prefs.digest.daily);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, {
      title: "Daily email",
      hint: "Content Hub"
    }, /*#__PURE__*/React.createElement("label", {
      className: "nc-digest"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: digest,
      onChange: () => this.setState({
        prefs: {
          ...prefs,
          digest: {
            ...(prefs.digest || {}),
            daily: !digest
          }
        },
        saved: false
      })
    }), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, "Email me a summary of My work each morning"), /*#__PURE__*/React.createElement("i", null, "Around 8 am: pieces assigned to you, reviews waiting on you, pieces sent back and new mentions. Only sent when there's something to do."))), /*#__PURE__*/React.createElement("div", {
      className: "nc-digest-acts"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "nc-link",
      disabled: this.state.testSent,
      onClick: this.digestTest
    }, this.state.testSent ? "On its way: it arrives within 5 minutes" : "Send me one now"))), /*#__PURE__*/React.createElement(Card, {
      title: "What reaches your bell",
      hint: "The bell keeps 90 days. Emails you already get are unchanged."
    }, error && /*#__PURE__*/React.createElement("p", {
      className: "nc-sub"
    }, "Could not save. Try again."), /*#__PURE__*/React.createElement("div", {
      className: "tblwrap"
    }, /*#__PURE__*/React.createElement("table", {
      className: "territory-table wa-table nc-pref-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Notification"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "In the bell"))), /*#__PURE__*/React.createElement("tbody", null, groups.map(g => /*#__PURE__*/React.createElement(React.Fragment, {
      key: g.name
    }, /*#__PURE__*/React.createElement("tr", {
      className: "nc-pref-group"
    }, /*#__PURE__*/React.createElement("td", {
      colSpan: 2
    }, g.name)), g.items.map(c => {
      const on = c.locked || this.inboxOn(c.type);
      return /*#__PURE__*/React.createElement("tr", {
        key: c.type
      }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("label", {
        htmlFor: `np-${c.type}`
      }, c.label), c.locked ? /*#__PURE__*/React.createElement("span", {
        className: "nc-locked"
      }, " \xB7 always on") : null), /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, /*#__PURE__*/React.createElement("input", {
        id: `np-${c.type}`,
        type: "checkbox",
        checked: on,
        disabled: !!c.locked,
        onChange: () => this.toggle(c.type)
      })));
    }))))))));
  }
  render() {
    const settings = this.settings();
    const {
      items,
      filter,
      app,
      more,
      busy,
      error,
      unread,
      saving,
      saved
    } = this.state;
    const btn = "k-button k-button-md k-rounded-md k-button-solid ";
    const actions = settings ? /*#__PURE__*/React.createElement(React.Fragment, null, saved && /*#__PURE__*/React.createElement("span", {
      className: "nc-saved"
    }, "Saved"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: btn + "k-button-solid-primary",
      disabled: saving || !this.state.prefs,
      onClick: this.save
    }, saving ? "Saving…" : "Save")) : /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: btn + "k-button-solid-base",
      disabled: !unread,
      onClick: this.readAll
    }, "Mark all read");
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view wa-view nc-page"
    }, /*#__PURE__*/React.createElement(PageHeader, {
      crumbs: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
        to: "/Settings"
      }, "Settings"), " \xB7 Notifications"),
      title: "Notifications",
      subtitle: settings ? "Choose which updates reach your bell" : "Assignments, mentions, finished jobs and anything that needs you",
      chips: settings ? [] : [{
        k: "Unread",
        v: String(unread || 0)
      }],
      actions: actions
    }), /*#__PURE__*/React.createElement("nav", {
      className: "wa-switch",
      "aria-label": "Notifications views"
    }, /*#__PURE__*/React.createElement("a", {
      className: "wa-tab" + (!settings ? " on" : ""),
      style: {
        cursor: "pointer"
      },
      onClick: () => this.props.history.push("/Notifications")
    }, "Notifications"), /*#__PURE__*/React.createElement("a", {
      className: "wa-tab" + (settings ? " on" : ""),
      style: {
        cursor: "pointer"
      },
      onClick: () => this.props.history.push("/Notifications/settings")
    }, "Settings")), settings ? this.renderSettings() : /*#__PURE__*/React.createElement(Card, {
      title: (FILTERS.find(([k]) => k === filter) || [])[1],
      hint: items ? `${items.length}${more ? "+" : ""} shown` : null
    }, /*#__PURE__*/React.createElement("div", {
      className: "wa-toolbar"
    }, /*#__PURE__*/React.createElement(Segmented, {
      options: FILTERS,
      value: filter,
      onChange: k => this.load({
        filter: k
      })
    }), /*#__PURE__*/React.createElement(Filters, null, /*#__PURE__*/React.createElement(Segmented, {
      options: APPS,
      value: app,
      onChange: k => this.load({
        app: k
      })
    }))), items === null ? /*#__PURE__*/React.createElement(Pending, null) : error ? /*#__PURE__*/React.createElement(Empty, null, "Notifications could not be loaded. Try again in a moment.") : items.length === 0 ? /*#__PURE__*/React.createElement(Empty, null, filter === "all" ? "Nothing yet. Assignments, mentions, finished jobs and anything that needs you will show here." : "Nothing here.") : /*#__PURE__*/React.createElement("div", {
      className: "nc-list"
    }, items.map(i => /*#__PURE__*/React.createElement(InboxRow, {
      key: i.id,
      item: i,
      onOpen: this.open,
      showSource: SOURCE_LABEL
    }))), more && /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: btn + "k-button-solid-base nc-more",
      disabled: busy,
      onClick: () => this.load(null, true)
    }, busy ? "Loading…" : "Show older")));
  }
}
const Routable = withRouter(NotificationsView);
export class NotificationsViewComponent extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement(Routable, {
      params: this.props.params
    });
  }
}
export default {
  NotificationsViewComponent
};